import { useAuth } from "@dl/web-core-js/auth";
import { PageHeader } from "@dl/web-core-js/shell";
import { Card } from "@dl/web-core-js/ui";
import { useTranslation } from "react-i18next";
import { NexpimView } from "../../views";
import { StockAdjustmentForm } from "./StockAdjustmentForm";

/** A manual adjustment or a count across several parts — the corrective tool on a page of its own. */
export function StockAdjustmentPage() {
  const { t } = useTranslation();
  const { hasView } = useAuth();
  const allowed = hasView(NexpimView.MANUFACTURING_STOCK);

  return (
    <>
      <PageHeader
        parent={{ to: "/manufacturing/stock", label: t("navigation.item.stock", "Stock") }}
        title={t("stock.adjust.page", "Adjust stock")}
        subtitle={t("stock.adjust.subtitle", "Always additive: the ledger gains movements and loses nothing.")}
      />
      <div className="p-4 lg:p-6">
        {allowed ? (
          <Card className="p-4 sm:p-5">
            <StockAdjustmentForm />
          </Card>
        ) : (
          <p className="text-[13px] text-ink-muted">
            {t("error.access-denied.detail", "Your account does not have permission to view this page.")}
          </p>
        )}
      </div>
    </>
  );
}
